var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-avatar"},[_c('a',{attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":"/assets/img/logoCambiarWee.webp"}})])])
}]

export { render, staticRenderFns }